import { combineReducers } from '@reduxjs/toolkit';

// Import reducers from different features
import authReducer from '../features/auth/auth_slice';
import songReducer from '../features/songs/song_slice'
import rehearsals from '../features/rehearsals/rehearsal_slice'
import songRequests from '../features/song_requests/song_request_slice'
import roleRequest from '../features/role_requests/role_request_slice'
import subscriptions from '../features/subscriptions/subscription_slice'
import transactions from '../features/transactions/transaction_slice'
import notifications from '../features/notifications/notification_slice'
import socket from '../features/socket/socket_slice'
import choirs from '../features/choirs/choir_slice'
import community from '../features/community/community_slice'
import global from '../features/global/global_slice'
import projects from '../features/projects/project_slice'
import profile from '../features/profile/profile_slice'

// UI reducers
import button_reducer from '../features/ui/ui_slice';


const rootReducer = combineReducers({
    // Map of state field names and corresponding reducers
    auth: authReducer,
    song: songReducer,
    rehearsal: rehearsals,
    song_request: songRequests,
    role_request: roleRequest,
    subscriptions: subscriptions,
    transactions: transactions,
    notifications: notifications,
    socket: socket,
    choirs: choirs,
    projects: projects,
    profile: profile,
    community: community,
    ui: button_reducer,
    global: global
    // Add other feature reducers here
});

export default rootReducer;
